import VideoChatContainer from "../../Componant/Chat/VideoChat";

const VideoChat = () => {
  return (
    <div className="page-body">
      <VideoChatContainer />
    </div>
  );
};

export default VideoChat;
